import AxiosDefault from "services/AxiosDefault";

export const CreateUpdateBootingAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/booting/create-update",
    data,
  });
  return response;
};

export const GetBootingAPI = async (placeId) => {
  const response = await AxiosDefault({
    method: "GET",
    url: `/booting/get/${placeId}`,
  });
  return response;
};

export const DeleteBootingAPI = async (data) => {
  console.log("data api ===>",data)
  const response = await AxiosDefault({
    method: "PATCH",
    url: "/booting/delete",
    data: data,
  });
  return response;
};
